export default [
  {
    path: "/selo/relatorios-ciclo",
    name: "selo-relatorios-ciclo",
    component: () => import("./components/RelatoriosCiclo.vue"),
    meta: { requiresAuth: true, requiresRelatoriosCiclo: true },
  },
  {
    path: "/selo/relatorios-ciclo/:uf/:ano/relatorio/:municipioId",
    name: "selo-relatorio-ciclo",
    component: () => import("./components/RelatorioFinal.vue"),
    meta: { requiresAuth: true, requiresRelatoriosCiclo: true },
  },
  {
    path: "/selo/fechamento",
    name: "selo-fechamento",
    component: () => import("./components/Fechamento.vue"),
    meta: { requiresAuth: true, requiresSeloFechamento: true },
  },
  {
    path: "/selo/fechamento/:uf/:ano/relatorio/:municipioId",
    name: "selo-relatorio-final",
    component: () => import("./components/RelatorioFinal.vue"),
    meta: { requiresAuth: true },
  },
];
